import Layout, { Stack } from '@/components/Layout'
import Text from '@/components/Text'
import type { HelpInfo as HelpInfoType } from '@/shared/api-generated-types'
import * as styles from './style'

export interface Props extends Partial<HelpInfoType> {}

const HelpInfo = ({ title, primaryAction, secondaryAction }: Props): JSX.Element => (
  <div className={styles.root}>
    <Layout>
      <Stack y className="pr-sm">
        {title && (
          <Text tag="h3" size="md" responsiveSize={{ sm: 'sm', lg: 'md' }} weight="md" className={styles.title}>
            {title}
          </Text>
        )}
        {!!primaryAction && <a href={primaryAction.url}> {primaryAction.label} </a>}
        {!!secondaryAction && <a href={secondaryAction.url}>{secondaryAction.label}</a>}
        <Text tag="h3" size="md" responsiveSize={{ sm: 'sm', lg: 'md' }} weight="md" className={styles.alternate}>
          Not in the US?
        </Text>
        <Text responsiveSize={{ sm: 'sm', lg: 'md' }} weight="md" className={styles.altNumber}>
          AU: +612-7908-7762
        </Text>
        <Text responsiveSize={{ sm: 'sm', lg: 'md' }} weight="md" className={styles.altNumber}>
          IN: +91-9321439549
        </Text>
      </Stack>
    </Layout>
  </div>
)

export default HelpInfo
